<template>
  <div class="app-page__container app-page__container--no-sidebar">
    <div v-if="isLoading" style="position: relative; min-height: 150px;">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as TeamActions from '@/store/actions/Team.actions';
import * as ApiService from '@/services/Api.service';
import * as NotificationService from '@/services/Notification.service';
import * as notificationTypes from '@/constants/notificationTypes';

export default {
  name: 'SlackRedirectView',

  props: {
    code: {
      type: String,
    },
    state: {
      type: String,
    },
  },

  data() {
    return {
      isLoading: true,
    };
  },

  mounted() {
    this.connectSlackWorkspace();
  },

  methods: {
    ...mapActions({
      updateTeam: TeamActions.UPDATE_TEAM,
    }),
    async connectSlackWorkspace() {
      let res;

      try {
        res = await ApiService.connectSlackWorkspace(this.code);

        const updateTeamPayload = {
          teamId: this.state,
          updatedTeam: {
            slackMeetingReminder: true,
            slackGoalNotification: true,
            slackData: res.data,
          },
        };

        await this.updateTeam(updateTeamPayload);

        try {
          await ApiService.joinSlackChannel(res.data.access_token, res.data.incoming_webhook.channel_id);
        } catch (error) {
          NotificationService.showNotification(
            notificationTypes.SLACK_JOIN_CHANNEL_WARN(res.data.incoming_webhook.channel),
            {
              duration: 10000,
            },
          );
        }
      } catch (error) {
        NotificationService.showNotification(notificationTypes.SLACK_CONNECT_ERROR);
      } finally {
        this.$router.replace(`/teams/edit/${this.state}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
